export enum Roles {
  User = 'User',
  Admin = 'Admin',
  EsaUser = 'EsaUser',
  EsaAdmin = 'EsaAdmin',
  TakeOffUser = 'TakeOffUser',
  TakeOffAdmin = 'TakeOffAdmin',
  ProductFinderUser = 'ProductFinderUser',
  ProductFinderAdmin = 'ProductFinderAdmin',
  DistSyndicationUser = 'DistSyndicationUser',
  DistSyndicationAdmin = 'DistSyndicationAdmin',
}
